// src/data/projects.js

export const PROJECT_CATEGORIES = [
  { id: 'product-design', label: 'Product Design' },
  { id: 'identity', label: 'Identité & Illustration' },
  { id: 'creative-lab', label: 'Creative Lab' }
];

// Liste complète de tes projets
export const projectsData = [
  // --- Product Design : projets où tu résous un problème ---
  {
    id: 'seekachu',
    category: 'product-design',
    title: 'Seekachu',
    desc: 'Moteur de recherche visuelle de cartes Pokémon par style artistique.',
    imgUrl: '/images/preview/preview-seekachu.jpg',
    link: '/projet/seekachu',
    liveUrl: 'https://seekachu.vercel.app',
    tech: ['Développement full-stack', 'UX / UI Design', 'Intelligence artificielle']
  },
  {
    id: 'ecommerce-mobilier',
    category: 'product-design',
    title: 'Vente privée · Box produit',
    desc: 'Box produit et audit UX pour un site e-commerce de mobilier.',
    cardTitle: 'Vente privée',
    cardDesc: 'Box produit et parcours de livraison repensés pour un site e-commerce.',
    imgUrl: '/images/preview/preview-vente-unique.jpg',
    link: '/projet/ecommerce-mobilier',
    figmaUrl: 'https://www.figma.com/design/yjm0BgnLPmf1eGbHSVvG1u/Exercice-UXUI-Vente-unique---Nathalie-LIU?t=pz0gw6Za8v0fl3aD-1',
    figmaEmbedSrc: 'https://embed.figma.com/design/yjm0BgnLPmf1eGbHSVvG1u/Exercice-UXUI-Vente-unique---Nathalie-LIU?embed-host=share',
    tech: ['Figma', 'UX Research', 'UI Design']
  },
  {
    id: 'covoiturage',
    category: 'product-design',
    title: 'Covoiturage d’entreprise · Plateforme SaaS en marque blanche',
    desc: 'Concevoir une app de mobilité pour deux publics : les salariés qui l’utilisent, et les RH qui l’achètent.',
    imgUrl: '/images/preview/preview-covoiturage.jpg',
    cardTitle: 'Solution de covoiturage',
    cardDesc: 'Application de covoiturage entre collaborateurs.',
    link: '/projet/covoiturage',
    figmaUrl: 'https://www.figma.com/design/9vQN9RtWsclwbvef1ZE1er/IIM-Projet-d-admission-%7C-2026?m=auto&t=pz0gw6Za8v0fl3aD-1',
    figmaEmbedSrc: 'https://embed.figma.com/design/9vQN9RtWsclwbvef1ZE1er/IIM-Projet-d-admission-%7C-2026?embed-host=share',
    tech: ['Figma', 'UX Research', 'UI Design']
  },
  {
    id: 'universe',
    category: 'product-design',
    title: 'Universe · Réseau social sécurisé pour préadolescents',
    desc: 'Concevoir un espace de messagerie où l’IA intercepte les messages violents avant leur envoi.',
    cardTitle: 'Universe',
    cardDesc: 'Réseau social sécurisé pour préados, modéré par IA.',
    imgUrl: '/images/preview/preview-universe.jpg',
    link: '/projet/universe',
    figmaUrl: 'https://www.figma.com/design/0eF9yI57hMFQGa5wfz7xbY/Universe-Maquette?m=auto&t=pz0gw6Za8v0fl3aD-1',
    figmaEmbedSrc: 'https://embed.figma.com/design/0eF9yI57hMFQGa5wfz7xbY/Universe-Maquette?embed-host=share',
    tech: ['Figma', 'UX Research', 'UI Design']
  },

  // --- Identité & Illustration : la mascotte Flowly et le visuel pur ---
  {
    id: 'flowly',
    category: 'identity',
    title: 'Flowly',
    desc: 'Création de la mascotte d’une app de suivi d’habitudes.',
    imgUrl: '/images/preview/preview-flowly.jpg',
    link: '/projet/flowly',
    liveUrl: 'https://www.myflowly.co/',
    instagramUrl: 'https://www.instagram.com/flowly.habits/',
    appStoreUrl: 'https://apps.apple.com/us/app/flowly-ai-habit-tracker/id6769358516?l=fr-FR'
  },
  {
    id: 'illustrations',
    category: 'identity',
    title: 'Illustrations',
    desc: 'Croquis et illustrations personnelles.',
    imgUrl: '/images/preview/preview-illustrations.png',
    link: '/projet/illustrations'
  },

  // --- Creative Lab : zone d'exploration (p5.js, Three.js...) ---
  {
    id: 'trajet',
    category: 'creative-lab',
    title: 'Trajectoire Souris',
    desc: 'Effet de traînée interactif minimaliste réalisé avec p5.js.',
    imgUrl: '/images/preview/preview-p5js-trajet.jpg',
    link: '/p5js-trajet'
  },
  {
    id: 'drawings',
    category: 'creative-lab',
    title: 'Sillage Dessiné',
    desc: 'Galerie interactive révélant mes dessins au passage de la souris.',
    imgUrl: '/images/preview/preview-p5js-drawings.jpg',
    link: '/p5js-drawings'
  },
  {
    id: '3dtext',
    category: 'creative-lab',
    title: '3D Text & Pancakes',
    desc: 'Scène WebGL avec modélisation Blender',
    imgUrl: '/images/preview/preview-threejs-3dtext.jpg',
    link: '/threejs-3dtext'
  },
  {
    id: 'haunted',
    category: 'creative-lab',
    title: 'Haunted House',
    desc: 'Maison hantée immersive avec lumières et textures PBR (Three.js).',
    imgUrl: '/images/preview/preview-threejs-hauntedhouse.jpg',
    link: '/threejs-hauntedhouse'
  },
  {
    id: 'galaxy',
    category: 'creative-lab',
    title: 'Galaxy Generator',
    desc: 'Générateur de galaxie interactif avec contrôles en temps réel (Three.js).',
    imgUrl: '/images/preview/preview-threejs-galaxy.png',
    link: '/threejs-galaxy'
  },
  {
    id: 'newjeans',
    category: 'creative-lab',
    title: 'NewJeans Never Die',
    desc: 'Projet créatif scrapbook. En construction 🚧',
    imgUrl: '/images/preview/preview-newjeansNeverDie.jpg',
    link: '/newjeansNeverDie'
  }
];
